module.exports = __webpack_public_path__ + "img/cbrr1.909a4bd7.gif";